module.exports = __webpack_public_path__ + "img/activedownarrow.502ecc5b.svg";